import React from "react";
import axios from "axios";
import SideBar from "./SideBar";
import { useEffect, useState } from "react";
import CurrencyDialog from "../views/CurrencyDialog";
import CurrencyUpdate from "../views/CurrencyUpdate";
import { Link, useLocation } from "react-router-dom";
import ReactShadowScroll from "react-shadow-scroll";
import useCollapse from "react-collapsed";
import HeaderName from "./HeaderName";
import { FaPaperPlane, FaArrowLeft } from "react-icons/fa";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";

function Dashboard() {
  const token = localStorage.getItem("token");
  const url = process.env.REACT_APP_APP_URL;
  // const url = 'http://localhost:9000/api/'
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const purchaseListId = useLocation().pathname.split("/")[2];

  const [scroll, setScroll] = useState(true);
  const [isExpanded, setExpanded] = useState(false);
  const [isAccData, setAccData] = useState(false);
  const [itemList, setItemList] = useState([]);

  const { getCollapseProps, getToggleProps } = useCollapse();

  const handleAdminChange = () => {
    setExpanded(!isExpanded);
  };

  const handleAccChange = () => {
    setAccData(!isAccData);
  };
  const [purchaseLists, setPurchaseLists] = useState([]);
  const [purchaseDetail, setPurchaseDetail] = useState([]);

  const [open, setOpen] = useState(false);

  const [showUpdate, setShowUpdate] = useState(false);
  const [id, setId] = useState("");
  const showDialog = () => setOpen(true);
  const [approveList, setApproveList] = useState([]);
  const showCurrencyUpdate = (val) => {
    setId(val);
    setShowUpdate(true);
  };
  const handleError = () => {
    Swal.fire({
      title: "Create Approve Form!",
      text: "Try again, Please.",
      icon: "warning",
      // showCancelButton: true,

      cancelButtonText: "Close",
    });
  };

  useEffect(() => {
    const getPurchaseLists = async () => {
      try {
        const res = await api.get("purchase-request/" + purchaseListId);

        setPurchaseLists(res.data.data);
        console.log(res.data.data, "detal");
      } catch (err) {}
    };

    const getRelatedMedicineLists = async () => {
      try {
        const res = await api.get("purchase-request/" + purchaseListId);
        console.log(res.data.data, "pur req");
        setApproveList(res.data.data, "appr lis");
        setPurchaseDetail(res.data.data);
        setItemList([
          ...res.data.data.medicineItems,
          ...res.data.data.procedureItems,
          ...res.data.data.accessoryItems,
          ...res.data.data.generalItems,
        ]);
        // setItemList([...itemList, ...res.data.data[0].accessoryItems])
      } catch (err) {}
    };

    getPurchaseLists();
    getRelatedMedicineLists();
    if (scroll) {
      document.body.style.overflow = "scroll";
    } else {
      document.body.style.overflow = "hidden";
    }
  }, []);

  return (
    <div classNameName='App'>
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className='wrapper'>
        {/* <!-- Navbar --> */}
        <HeaderName />

        <SideBar />

        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}

        {/* <!-- Content Wrapper. Contains page content --> */}
        <div className='content-wrapper'>
          {/* <!-- Content Header (Page header) --> */}
          <div className='content-header'>
            <div className='container-fluid'>
              <div className='row mb-2'>
                <div className='col-sm-12'>
                  <ol className='breadcrumb'>
                    <li className='breadcrumb-item'>
                      <Link to='/purchase'>
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li
                      className='breadcrumb-item active'
                      style={{ marginTop: "0.1em" }}
                    >
                      Purchase List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section class='content'>
            <div class=''>
              <div className='row ml-2'>
                <h3 className='mr-2'>Purchase Request Detail</h3>
                <div className='card col-4 mt-1 vh-10'>
                  <table className='table table-borderless text-lg'>
                    <div>
                      <tr>
                        <td>Purchase Date</td>
                        <td>
                          {purchaseLists.date
                            ? purchaseLists.date.split("T")[0]
                            : ""}
                        </td>
                      </tr>
                      <tr>
                        <td>Branch Name</td>
                        <td>
                          {purchaseLists.relatedBranch
                            ? purchaseLists.relatedBranch.name
                            : "HO"}
                        </td>
                      </tr>
                      <tr>
                        <td>Total Quantity</td>
                        <td>{purchaseLists.totalQTY}</td>
                      </tr>
                      <tr>
                        <td>Total Price</td>
                        <td>{purchaseLists.totalPrice}</td>
                      </tr>
                      <tr>
                        <td>Remark</td>
                        <td>{purchaseLists.remark}</td>
                      </tr>
                    </div>
                  </table>
                  <div className='d-flex justify-content-center gap-3 mb-3'>
                    {purchaseLists.relatedApprove ? (
                      <Link
                        to={"/pur-rec/" + purchaseListId}
                        state={{ data: approveList }}
                        className='btn btn-primary'
                      >
                        Purchase Received
                      </Link>
                    ) : (
                      <div>
                        <button
                          onClick={handleError}
                          className='btn btn-primary'
                        >
                          Purchase Received
                        </button>
                      </div>
                    )}
                    &nbsp;
                    {/* <button className='btn  btn-danger'>Delete</button> */}
                  </div>
                </div>
                <div className=' col-8 right-table mt-1 rounded shadow-m'>
                  <div className='card px-3 py-1'>
                    <h6 className='py-3'>Purchase Unit List</h6>

                    <table className='table table-striped'>
                      <thead className=''>
                        <tr>
                          <th>No</th>
                          <th>Item Name</th>
                          <th>Quantity</th>
                          <th>Price</th>
                          <th>Sub Total</th>
                        </tr>
                      </thead>
                      {/* <?php $i=1; ?> */}
                      <tbody className=''>
                        {itemList.map((item, i) => (
                          <tr>
                            <td>{++i}</td>
                            <td>
                              {item.item_id
                                ? item.item_id.medicineItemName
                                : "no"}

                              {item.item_id
                                ? item.item_id.procedureItemName
                                : "no"}
                              {item.item_id
                                ? item.item_id.accessoryItemName
                                : "no"}
                              {item.item_id
                                ? item.item_id.accessoryItemName ||
                                  item.item_id.generalItemName
                                : "no"}
                            </td>

                            <td>{item ? item.requestedQty : ""}</td>
                            <td>
                              {item.purchasePrice ? item.purchasePrice : ""}
                            </td>
                            <td>{item.subTotal ? item.subTotal : ""}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              {/* 
                  <CurrencyDialog
                    open={open}
                    close={() => setOpen(false)}
                    setOpen={setOpen}
                    setPurchaseLists={setPurchaseLists}
                    purchaseLists={purchaseLists}
                  /> */}
            </div>
          </section>
        </div>

        {/* <!-- /.content-wrapper --> */}
        <footer className='main-footer'>
          <strong>
            Copyright &copy; 2017-2020{" "}
            <a href='http://www.kwintechnologies.com'>K-win Technology</a>.
          </strong>
          All rights reserved.
        </footer>

        {/* <!-- Control Sidebar --> */}
        <aside classNameName='control-sidebar control-sidebar-dark'>
          {/* <!-- Control sidebar content goes here --> */}
        </aside>

        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default Dashboard;
